<template>
    <IconBase  v-bind="$props" v-on="$listeners">
        <rect x="0.5" y="0.5" width="17" height="17" rx="5.5" fill="#D7D8FF" stroke="#7019FD" />
        <path
            d="M3.72727 9.75L4.59091 8.86364L7.59091 11.8182L13.7955 5.63636L14.6818 6.52273L7.59091 13.5909L3.72727 9.75Z"
            fill="#7019FD" />
    </IconBase>
</template>

<script>
import IconBase from './iconBase/IconBase.vue'
import iconProps from './iconBase/iconProps.js'

export default {
  components: { IconBase },
  props: {
    ...iconProps,
    height: {
        ...iconProps.height,
        default: 18,
    },
    width: {
        ...iconProps.width,
        default: 18,
    },
    viewBox: {
        ...iconProps.viewBox,
        default: "0 0 18 18",
    }
  },
}
</script>